<div [ngClass]="{'sideStyle': !fromGlobalSearch && displayGlobalSearchTab }" >
  <div style="height: 100vh; width: 53px; min-width: 53px; background-color: white;" class="sideBtn" *ngIf="associationTypeName == 'account' && !fromGlobalSearch && displayGlobalSearchTab  && isShowSideBtn">
    <button pButton pRipple type="button" pTooltip="Accounts" tooltipPosition="right" class="p-button-rounded"
        label="A"  style="margin-bottom: 10px;" (click)="navigateToAccount()"  *ngIf="isShowSideBtn"
        [ngStyle]="{'background-color': '#607D8B'}" ></button>
    <button pButton pRipple type="button" pTooltip="Account Contacts" tooltipPosition="right"
        class="p-button-rounded" label="C" *ngIf="isShowSideBtn"
        [ngStyle]="{'background-color': 'p-button-secondary'}"></button>
  </div>
<div class="p-grid">
  <!-- this is header section -->
  <div class="p-col-12" *ngIf="isMenuShow">
    <p-menubar [model]="menuItems">
      <ng-template pTemplate="start" style="width: 100%;">
        <span *ngIf="associationTypeName == 'vendor' || associationTypeName == 'account'" class="btnBars" (click)="isShowSideBtn = !isShowSideBtn;changeSideHeaderPurchaseMenu(isShowSideBtn)"
          style="vertical-align: sub;">
          <i class="pi pi-angle-double-left" *ngIf="isShowSideBtn"></i>
          <i class="pi pi-angle-double-right" *ngIf="!isShowSideBtn"></i>
        </span>
        <h2 style="display: inline;">Contacts - </h2>
        <span style="width: fit-content;">
          <p-dropdown [options]="recentItems" id="recentItems" (onChange)="recentUpdate()" [(ngModel)]="selectedRecent"
            optionLabel="label" appendTo="body">
          </p-dropdown>
        </span>
        <span *ngIf=" associationTypeName == 'account'" style="width: fit-content; margin-left: 2px;">
          <p-dropdown (onChange)="onAccountChannelChanged($event)" [(ngModel)]="selectedChannelN1" optionLabel="name" [options]="channelsN" appendTo="body" [baseZIndex]="0"></p-dropdown>
        </span>
        <span style="width: fit-content;">
          <p-toggleButton class="p-mb-2 p-ml-2" onLabel="Active" offLabel="InActive" [onIcon]="'pi pi-check'"
            [offIcon]="'pi pi-times'" iconPos="right" [(ngModel)]="isActive" (onChange)="onStatusChanged()">
          </p-toggleButton>
        </span>
        <!-- Search Bar -->
        <span class="p-input-icon-left" style="float: right; margin: 2px 5px 0px 5px;">
          <i class="pi pi-search"></i>
          <input pInputText type="text" [formControl]="searchControl" placeholder="Search..." />
        </span>
        <!-- Refresh Icon -->
        <span class="btnBars p-mt-1" style="float: right;" pTooltip="Refresh" tooltipPosition="top" (click)="refreshList($event)">
          <i class="pi pi-refresh"></i>
        </span>
        <!-- <app-filters [listCols]="savedListColsVM"
          [selectedParentModule]="{name:associationTypeName,objectId:objectTypeId,channelId: globalChannelId !== 0 ? globalChannelId : selectedChannelN1?.id}"
          [saveFilterData]="saveFilterData" (applyFiltersColumns)="applyFilters($event)"></app-filters> -->
      </ng-template>
      <ng-template pTemplate="end" style="width: 100%;"></ng-template>
    </p-menubar>
  </div>
  <!-- this is table body section -->
  <div class="p-col-12">
   <div class="p-grid">
    <div  [ngClass]="{'p-col-12 p-lg-12': selectedView=='list', 'p-col-12 p-lg-3': selectedView=='split', 'p-d-none': ( selectedView=='split' && isLeftTableHide)}">
    <div class="card" *ngIf="selectedColumn?.length">
      <p-contextMenu #cm [model]="configMenuItemsCM" (onShow)="onContextMenu($event)"></p-contextMenu>
              <!-- Global Search Table -->
        <div *ngIf="selectedView == 'split' && fromGlobalSearch">
            <app-global-search-table [isVisible]="fromGlobalSearch" [globalSearchData]="globalSearchData"(refresh)="onRefreshList($event)">
            </app-global-search-table>
        </div>
      <p-table *ngIf="selectedColumn?.length > 0  && !fromGlobalSearch" #contactsTable appFloatThead [value]="contacts" [totalRecords]="totalRecords" [columns]="selectedView == 'list' ? savedListColsVM : splitView"
        [rows]="pageSize" [paginator]="true" [resizableColumns]="true" styleClass="p-datatable-gridlines"
        [style]="{width:'100%'}" [contextMenu]="cm" [scrollable]="true" dataKey="id" selectionMode="single"
        [(contextMenuSelection)]="selectedContact" [(selection)]="selectedContact" (onRowSelect)="onRowSelect($event); displayGlobalSearchTab = false"
        (onRowUnselect)="onRowUnselect($event);" [floatTableRef]="contactsTable" floatTableClassRef="floatthead"
        [lazy]="true" (onSort)="onSortColumn($event)" (onPage)="getData($event)"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true"
        [rowsPerPageOptions]="tableShowMore">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columns">
              <th *ngIf="col.enabled" [pSortableColumn]="col.columnName"
              style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                  {{col.name}}{{col?.value?.length}}
                  <p-sortIcon [field]="col.columnName" ariaLabel="Activate to sort"
                      ariaLabelDesc="Activate to sort in descending order"
                      ariaLabelAsc="Activate to sort in ascending order">
                  </p-sortIcon>
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr [pContextMenuRow]="rowData" [pSelectableRow]="rowData">
            <!-- Loop through each column in the contactCols array -->
            <ng-container *ngFor="let col of columns">
              <td *ngIf="col.enabled" style="text-align: left;">
                <!-- Handle phone number format specifically -->
                <ng-container *ngIf="phoneNumberCodeMap[col.columnName]; else elseData">
                  <span>
                    {{ rowData[col.columnName] | phoneNumber: rowData[phoneNumberCodeMap[col.columnName]] }}
                  </span>
                </ng-container>
                <ng-template #elseData>
                  <ng-container *ngIf="isSocialColumn(col.columnName); else elseData2">
                    <a href="{{ rowData[col.columnName] | url }}" target="_blank">
                      {{ rowData[col.columnName] | shorten }}
                    </a>
                  </ng-container>
                  <ng-template #elseData2>
                    <ng-container *ngIf="isDescriptionColumn(col.columnName)">
                      {{ rowData[col.columnName] | slice:0:50 }}{{ rowData[col.columnName]?.length > 50 ? '...' : '' }}
                    </ng-container>
                    <ng-container *ngIf="isDateColumn(col.columnName)">
                      {{ rowData[col.columnName] | localDate: 'date' }}
                    </ng-container>
                    <ng-container *ngIf="!isDateColumn(col.columnName) && !isDescriptionColumn(col.columnName)">
                      {{ rowData[col.columnName] }}
                    </ng-container>
                  </ng-template>
                </ng-template>
              </td>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="30"><div class="p-text-center">{{noCaseFindOrLoadingText}}</div></td>
          </tr>
        </ng-template>
      </p-table>
     </div>
    </div> 
              <!-- Contact details -->
            <div class="p-col-12 p-lg-9" [ngClass]="{'p-lg-12': (contactDetailsScreenEnabled || isLeftTableHide)}" *ngIf="selectedView == 'split' && selectedContact">
                <div class="card">
                  <div class="p-grid">
                    <div class="p-col-12">
                      <p-menu #configmenua id="config_menu"
                              [model]="configMenuItems"
                              (onShow)="onContextMenu()"
                              [popup]="true"></p-menu>
                      <div class="tabviewIcons">
                          <div class="btnBars" pTooltip="Minimize" tooltipPosition="top" (click)="showMenu('table')" *ngIf="isLeftTableHide">
                              <i class="pi pi-minus-circle"></i>
                          </div>
                          <div class="btnBars" pTooltip="Maximize" tooltipPosition="top" (click)="hideMenu('table')" *ngIf="!isLeftTableHide">
                              <i class="pi pi-plus-circle"></i>
                          </div>
                          <div class="btnBars" pTooltip="Show Menu Bar" tooltipPosition="top" (click)="showMenu('menu')" *ngIf="!isMenuShow">
                              <i class="pi pi-arrow-down"></i>
                          </div>
                          <div class="btnBars" pTooltip="Hide Menu Bar" tooltipPosition="top" (click)="hideMenu('menu')" *ngIf="isMenuShow">
                              <i class="pi pi-arrow-up"></i>
                          </div>
                          <div class="btnBars" (click)="configmenua.toggle($event)">
                              <i class="pi pi-bars"></i>
                          </div>
                          <div class="btnBars" (click)="backListView()">
                              <i class="pi pi-times"></i>
                          </div>
                      </div>
                      <p-tabView>
                        <p-tabPanel header="Overview">
                          <div class="p-m-2">
                              <app-shared-detail-block moduleName="Contact" [column]="contactColsAllTemp"
                                  [data]="filteredContacts">
                              </app-shared-detail-block>
                          </div>
                        </p-tabPanel>
                        <p-tabPanel header="Activity">
                          <app-lion-shared-activities [objectTypeId]="objectTypeId" [objectId]="app?.objectType" [selectedObject]="filteredContacts"
                              [isViewMode]="selectedContact.statusId != 1">
                          </app-lion-shared-activities>
                        </p-tabPanel>
                      </p-tabView>
                    </div>
                  </div>
                </div>
            </div> 
        </div>
  </div>
 </div>
</div>

<app-shared-column-setting-modal [displayColumnSettings]="displayColumnSettings" moduleName="Contact"
  [disabledLabelNames]="disabledLabelNames" [selectedView]="selectedView" [settingsObj]="columnSettingsN" [modal]="true"
  [channelId]="selectedChannelN" (savedColumnSettings)="savedColumnSettings()"
  (cancelColumnSettings)="cancelColumnSettings()">
</app-shared-column-setting-modal>


@if(displayContactAddEdit){
<app-add-edit-form [displayContactAddEdit]="displayContactAddEdit" [selectedContact]="selectedContact" [mainContactModule]="mainContactModule"
  (loadContactList)="loadContactList()"  [contactModalHeader]="contactModalHeader" [mode]="contactPopupOpenMode" [selectedChannel]="{id:globalChannelId}"
  (displayContactAddEditChange)="displayContactAddEditChange($event)"
  [associationTypeName]="associationTypeName"></app-add-edit-form>
}

@if(displayActiveInactiveModal){
<app-lion-active-inactive-modal [displayActiveInactiveModal]="displayActiveInactiveModal"
  [activeInactiveFormType]="activeInactiveFormType" [id]="selectedIdForActiveInactive"
  [contactAssociationTypeId]="selectedContact.contactAssociationTypeId" [statusId]="statusId" [moduleName]="moduleName"
  (cancelActiveInactiveModal)="cancelActiveInactiveModal()" (saveActiveInactiveModal)="saveActiveInactiveModal()">
</app-lion-active-inactive-modal>
}
